import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";

import { parseSummaryBlankQuestion } from "../../../../../utils/parseUtils";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import { typeInfo } from "../../../../../constants/typeInfo";

import UserInputBar from "../../widgets/UserInputBar";
import CommonPage from "../../common/CommonPage";

const SummaryBlankPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [selectedBlankIndex, setSelectedBlankIndex] = useState(0);
  const [userInput, setUserInput] = useState("");
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);

  const currentPage = pageList[currentIndex] || {
    type: "",
    question: [],
  };

  const selectedBlank = currentPage.question.find(
    (element) =>
      element.index === selectedBlankIndex && element.type === "blank"
  );

  useEffect(() => {
    if (pageList.length > 0) return;

    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }
    setPageList(
      section.question.data.map((question) => {
        return {
          ...question,
          question: parseSummaryBlankQuestion(question.question),
          answer: question.answer.split(" / "),
          isSubmitted: false,
          isCorrect: false,
        };
      })
    );
    setCurrentIndex(0);
  }, [section]);

  useEffect(() => {
    setUserInput("");
    setSelectedBlankIndex(-1);
  }, [currentIndex]);

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  const changeSelectedBlank = (element) => {
    if (element.isSubmitted) return alert("이미 정답 제출한 빈칸입니다.");
    setSelectedBlankIndex(element.index);
    currentPage.question.forEach((question) => {
      if (question.type === "blank") {
        if (question.index === element.index) {
          setUserInput(question.input);
        }
      }
    });
  };

  const handleNextPage = () => {
    if (currentIndex < pageList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      let isAllAnswered = true;

      pageList.forEach((page, index) => {
        if (!page.isSubmitted) {
          isAllAnswered = false;
        }
      });

      if (isAllAnswered) {
        if (!isPreview && !isReview) {
          dispatch(
            updateSection({
              sectionId: section.id,
              data: { is_finished: true, answer: pageList },
            })
          );
        }
        alert("학습이 완료되었습니다.");
        setCurrentStep(2);
      } else {
        alert("문제를 덜 풀었습니다.");
      }
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleSetAnswer = () => {
    const nextElement = currentPage.question
      .filter(
        (element) => element.type === "blank" && element.isSubmitted === false
      )
      .find((element) => element.index > selectedBlankIndex);
    if (nextElement) {
      changeSelectedBlank(nextElement);
    }

    const question = [];
    currentPage.question.forEach((element) => {
      if (element.type === "blank" && element.index === selectedBlankIndex) {
        question.push({ ...element, input: userInput });
      } else {
        question.push(element);
      }
    });

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          question: question,
        };
      }
      return prevPage;
    });

    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  const handleSubmit = () => {
    if (currentPage.isSubmitted) return;
    if (
      currentPage.question
        .filter((element) => element.type === "blank")
        .some((element) => element.input === "")
    ) {
      return alert("모든 빈칸을 채워주세요.");
    }

    const correct = currentPage.question
      .filter((element) => element.type === "blank")
      .every(
        (element, index) =>
          (element.hint + element.input).toLowerCase() ===
          currentPage.answer[index].toLowerCase()
      );
    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          isSubmitted: true,
          isCorrect: correct,
        };
      }
      return page;
    });

    setOverlayVisible(true);
    setIsCorrect(correct);
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    setTimeout(() => {
      setOverlayVisible(false);
    }, 600);
  };

  return (
    <CommonPage
      currentIndex={currentIndex}
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      totalNo={pageList.length}
      currentPage={currentPage}
      paragraph={section?.question.full_text}
      overlayVisible={overlayVisible}
      isCorrect={isCorrect}
      handleSubmit={handleSubmit}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "30px",
          width: "90%",
        }}
      >
        <div
          style={{
            fontSize: "20px",
            marginBottom: "20px",
          }}
        >
          {"빈칸을 채우세요."}
        </div>
        <div
          style={{
            fontSize: "28px",
          }}
        >
          {currentPage.question.map((element, index) => {
            if (element.type === "text") {
              return element.content;
            } else if (element.type === "blank") {
              const userAnswer = currentPage.isSubmitted
                ? currentPage.answer[element.index].slice(1)
                : element.input;
              const blankLength = element.length - 6;
              const isSelected = element.index === selectedBlankIndex;

              return (
                <span
                  key={index}
                  onClick={() => changeSelectedBlank(element)}
                  style={{
                    display: "inline-block",
                    minWidth: 20,
                    marginRight: 4,
                    marginLeft: 4,
                    cursor: "pointer",
                    letterSpacing: userAnswer === "" ? "0" : null,
                    backgroundColor: isSelected
                      ? typeInfo["comprehensive"].backgroundColor
                      : userAnswer === ""
                      ? "transparent"
                      : "#EBEBEB",
                  }}
                >
                  <span
                    style={{
                      color: typeInfo["comprehensive"].color,
                    }}
                  >
                    {element.hint}
                  </span>
                  {userAnswer || "_".repeat(blankLength)}
                </span>
              );
            }
            return null;
          })}
        </div>
        <div style={{ position: "relative", width: "60%", marginTop: "50px" }}>
          <UserInputBar
            handleSetAnswer={handleSetAnswer}
            handleChange={handleChange}
            userInput={userInput}
            type={"comprehensive"}
            onlyUnderline={true}
            isSubmitted={selectedBlank?.input !== ""}
            hint={selectedBlank?.hint}
          />
        </div>
      </div>
    </CommonPage>
  );
};

export default SummaryBlankPage;
